var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFragList(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 32,
    viewBox: "0 0 160 65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#6369D1",
    strokeWidth: 2,
    d: "M0 65L0 0 160 0 160 65"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#6369D1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 3H80V5H16zM0 0H8V8H0z",
    transform: "translate(40 14)"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#6369D1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 3H80V5H16zM0 0H8V8H0z",
    transform: "translate(40 30)"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#6369D1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 3H80V5H16zM0 0H8V8H0z",
    transform: "translate(40 46)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#6369D1",
    d: "M48 62v3h-8v-3h8z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFragList);
export default __webpack_public_path__ + "static/media/frag_list.3bf61706de98ce60d60dea714c48d141.svg";
export { ForwardRef as ReactComponent };